import type { ReactNode } from 'react';
import styles from './ToolForm.module.css';

interface ToolFormFieldProps {
  label: string;
  hint?: string;
  children: ReactNode;
}

/** A labelled control with an optional hint, shared by the HTTP and lookup forms. */
export const ToolFormField = ({ label, hint, children }: ToolFormFieldProps) => (
  <label className={styles.field}>
    <span className={styles.fieldLabel}>{label}</span>
    {hint && <span className={styles.fieldHint}>{hint}</span>}
    <div className={styles.fieldControl}>{children}</div>
  </label>
);
